// ===============================
// ACTUALIZAR CONTADOR DE CARRITO
// ===============================
function actualizarContadorCarrito() {
  const carrito = JSON.parse(localStorage.getItem('carrito')) || [];
  const totalCantidad = carrito.reduce((acc, item) => acc + item.cantidad, 0);
  const cartCountEl = document.querySelector('.cart-count');
  if (cartCountEl) cartCountEl.textContent = totalCantidad;
}

// ===============================
// AGREGAR AL CARRITO
// ===============================
function agregarAlCarrito(producto) {
  if (!producto || producto.cantidad <= 0) return;

  const carrito = JSON.parse(localStorage.getItem('carrito')) || [];
  const existe = carrito.find(p => p.id.toString() === producto.id.toString());

  if (existe) {
    existe.cantidad += producto.cantidad;
  } else {
    carrito.push(producto);
  }

  localStorage.setItem('carrito', JSON.stringify(carrito));
  actualizarContadorCarrito();
}

// ===============================
// ELIMINAR DEL CARRITO
// ===============================
function eliminarDelCarrito(id) {
  let carrito = JSON.parse(localStorage.getItem('carrito')) || [];
  carrito = carrito.filter(p => p.id.toString() !== id.toString());
  localStorage.setItem('carrito', JSON.stringify(carrito));
  actualizarContadorCarrito();
}

// ===============================
// VACIAR CARRITO
// ===============================
function vaciarCarrito() {
  localStorage.setItem('carrito', JSON.stringify([]));
  actualizarContadorCarrito();
}

// ===============================
// CONECTAR BOTONES DEL CARRITO AL CLICK
// ===============================
document.addEventListener("DOMContentLoaded", () => {
  actualizarContadorCarrito(); // actualizar al cargar

  const botones = document.querySelectorAll('.btn-carrito');

  botones.forEach(btn => {
    btn.addEventListener('click', () => {
      const card = btn.closest('.card');
      const cantidadInput = card.querySelector('.cantidad');
      const cantidad = cantidadInput ? parseInt(cantidadInput.value) || 1 : 1;

      const producto = {
        id: btn.dataset.id,
        nombre: btn.dataset.nombre,
        precio: parseFloat(btn.dataset.precio),
        cantidad: cantidad
      };

      agregarAlCarrito(producto);

      // Mensaje opcional
      //alert(`Se agregó "${producto.nombre}" al carrito.`);
    });
  });
});